import FloorGeneralInformation from './FloorGeneralInformation';

export default FloorGeneralInformation;